import { omit } from 'lodash-es';

import { BaseApiError } from './BaseApiError';
import type { IErrorPayload } from './types';

export class ApiError extends BaseApiError {
  public status: number;

  public details?: any;

  constructor(errorPayload: IErrorPayload) {
    super(errorPayload.message);
    this.name = 'API Response Error';
    this.status = errorPayload.status;

    this.details = omit(errorPayload, ['message', 'status']);
  }
}
